import PreviousEmployment from "@model/PreviousEmployment";
import AssociatedListViewModel from "@vm/List/AssociatedListViewModel";
import { inject, injectable } from "inversify";
import TYPES from "../../inversify.types";
// There is error in babel
// remove this after https://github.com/babel/babel/issues/9838
// will be fixed
void TYPES;
void inject;

@injectable()
export default class PreviousEmploymentListVM extends AssociatedListViewModel<
  PreviousEmployment,
  AssociatedRepository<PreviousEmployment>
> {
  constructor(@inject(TYPES.PreviousEmploymentRepository) repository: AssociatedRepository<PreviousEmployment>) {
    super(repository);
    this.scroll = false;
    this.save = false;
  }
}
